export default __webpack_public_path__ + "static/media/notScanIdCard.8ffc473f.svg";